export const uiVideoPlayer = {
    name: 'UI Video Player',
    description: '',
    displayField: 'videoProvider',
    fields: {
        videoProvider: {
            name: 'Video provider',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: [{ in: ['Wistia'] }]
        },
        videoId: {
            name: 'Video id',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        }
    }
};
//# sourceMappingURL=uiVideoPlayer.js.map